export interface UpdateClosedDaysRequest {
  branchCode: string
  year: number | string
  month: number | string
  days: string[]
}

export function UpdateClosedDaysRequestToJSON(
  value: UpdateClosedDaysRequest
): any {
  return {
    branch_code: value.branchCode !== '' ? value.branchCode : undefined,
    year: value.year !== '' ? value.year : undefined,
    month: value.month !== '' ? value.month : undefined,
    days: Array.isArray(value.days) ? value.days : undefined
  }
}
